export default {
	PROJECT_TYPES: [
		[1, 'Curb Adapters'],
		[2, 'Pitched Curb'],
		[3, 'Straight Curb']
	]
}